export default __webpack_public_path__ + "static/media/SWT0440.34I-21084_-20736_0.e3072da8.jpg";